import React, { useState } from 'react';
import './PromotionButton.css';
import Container from '../Container';

const PromotionButton = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <Container>
      <div className="promotion-section">
        <p className="promotion-text">
          Para conocer más sobre nuestras promociones y ofertas especiales, por favor haga clic en el siguiente botón
        </p>
        <button 
          className="promotion-button"
          onClick={() => setIsModalOpen(true)}
        >
          Ver promociones
        </button>

        {isModalOpen && (
          <div className="modal-overlay" onClick={() => setIsModalOpen(false)}>
            <div className="modal-content" onClick={e => e.stopPropagation()}>
              <button 
                className="modal-close"
                onClick={() => setIsModalOpen(false)}
              >
                ×
              </button>
              <div className="modal-scroll">
                <h2>REGLAS Y CONDICIONES DE PROMOCIÓN</h2>
                <div className="promotion-rules">
                  <p>
                    La promoción de <strong>30% de descuento</strong> se rige por las
                    siguientes reglas y condiciones. Al participar, el cliente acepta
                    las disposiciones indicadas para la aplicación de este beneficio.
                  </p>

                  <h3>1. Aplicación del descuento</h3>
                  <p>
                    El <strong>30% de descuento</strong> aplica exclusivamente en la
                    compra conjunta de:
                  </p>
                  <ul>
                    <li>
                      <strong>Aro + lentes oftálmicos (graduados)</strong>
                    </li>
                  </ul>

                  <h3>2. Productos excluidos de la promoción</h3>
                  <p>El descuento no aplica para los siguientes productos:</p>
                  <ul>
                    <li>Lentes de contacto (convencionales o especiales)</li>
                    <li>Lentes de sol, cuando se compran de forma individual</li>
                    <li>Líquidos de limpieza</li>
                    <li>Líquidos para lentes de contacto</li>
                    <li>Accesorios en general</li>
                  </ul>

                  <h3>3. Condición especial de aplicación del descuento</h3>
                  <p>
                    Si el cliente realiza una compra base de <strong>aro + lentes</strong>,
                    se permite extender el beneficio del <strong>30% de descuento</strong>
                    a productos adicionales dentro de la misma factura.
                  </p>

                  <p>Ejemplos de aplicación:</p>
                  <ul>
                    <li>
                      <strong>Aro + lentes + aro de sol</strong>: se puede aplicar el
                      30% a toda la compra.
                    </li>
                    <li>
                      <strong>Aro + lentes + lentes de contacto</strong>: se puede
                      aplicar el 30% a toda la compra.
                    </li>
                  </ul>

                  <p>
                    <strong>Condición obligatoria:</strong> siempre debe existir la
                    compra base de <strong>aro + lentes oftálmicos</strong> para
                    habilitar el descuento en los demás productos.
                  </p>

                  <h3>4. Restricciones generales</h3>
                  <ul>
                    <li>No aplica en compras individuales de productos excluidos.</li>
                    <li>No es acumulable con otras promociones.</li>
                    <li>Aplica únicamente sobre precios regulares.</li>
                    <li>El descuento debe aplicarse en una sola factura.</li>
                  </ul>

                  <h3>Forma de pago</h3>
                  <p>No aplica con <strong>Tasa 0 de Credomatic</strong>.</p>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </Container>
  );
};

export default PromotionButton;